import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=4152d030&scoped=true&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"
import style0 from "./Template.vue?vue&type=style&index=0&id=4152d030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152d030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
